import axios from 'axios';

// Shared axios instance for the LYRA backend.
//
// The auth token is read from localStorage on EVERY request via an
// interceptor — not captured once at module import time — so it always
// reflects the current login/logout state (fixes the stale-token bug where
// requests were sent with `Bearer null` until a hard refresh).
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lyraToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
